import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Alert,
} from "reactstrap"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"


import { useDispatch, useSelector } from "react-redux"
import { userForgetPassword, clearForgetPasswordState } from "store/actions"

// import components
import FullPageLoader from "components/Common/FullPageLoader"
import EnvironmentBadge from "components/Common/EnvironmentBadge"

const Recoverpw2 = () => {
  const dispatch = useDispatch()
  
  const appName = process.env.REACT_APP_APP_NAME || "CMS"
  
  //meta title
  document.title = "Recover Password "

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: values => {
      dispatch(userForgetPassword(values, "BASE64"))
    },
  })

  const { forgotError, forgotSuccessMsg, loading } = useSelector(state => ({
    forgotError:
      state.ForgetPassword?.forgetError?.message ||
      state.ForgetPassword?.forgetError?.description,
    forgotSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
    loading: state.ForgetPassword.loading,
  }))

  // Clear state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearForgetPasswordState())
    }
  }, [dispatch])

  // Handle clear state when clicking Back to Login
  const handleBackToLogin = () => {
    dispatch(clearForgetPasswordState())
  }


  return (
    <React.Fragment>
      <FullPageLoader show={loading} message="Sending reset link..." />
      <EnvironmentBadge position="top-right" />
      <div className="d-flex" style={{ minHeight: '100vh', margin: 0, padding: 0 }}>
        <div className="w-100 d-flex">
          <div className="d-none d-lg-block" style={{ width: '66.66%' }}>
            <div className="d-flex align-items-center justify-content-center" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              minHeight: '100vh',
              width: '100%'
            }}>
              <div className="text-center text-white p-5">
                <h1 className="display-6 mb-4">{appName}</h1>
                <h2 className="display-4 fw-bold mb-4">Forgot Password?</h2>
                <p className="lead mb-0">No worries, we'll help you reset it</p>
              </div>
            </div>
          </div>
          <div style={{ width: '33.33%' }}>
              <div className="auth-full-page-content p-md-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="my-auto">
                      <div className="mt-4">
                        {forgotSuccessMsg ? (
                          // Success state - show confirmation message
                          <div className="text-center">
                            <div className="mb-4">
                              <i className="mdi mdi-check-circle-outline text-success" style={{ fontSize: '4rem' }}></i>
                            </div>
                            <h4 className="text-success mb-3">Check Your Email!</h4>
                            <div className="alert alert-success text-center mb-4" role="alert">
                              We've sent password reset instructions to:
                              <br />
                              <strong>{validation.values.email}</strong>
                            </div>
                            <p className="text-muted mb-4">
                              Please check your email and follow the instructions to reset your password.
                              If you don't see the email, check your spam folder.
                            </p>
                            <div className="text-center">
                              <Link 
                                to="/login" 
                                className="btn btn-primary"
                                onClick={handleBackToLogin}
                              >
                                Back to Login
                              </Link>
                            </div>
                          </div>
                        ) : (
                          // Form state - show reset form
                          <>
                            <div
                              className="alert alert-success text-center mb-4"
                              role="alert"
                            >
                              Enter your Email and instructions will be
                              sent to you!
                            </div>

                            <Form
                              className="form-horizontal"
                              onSubmit={e => {
                                e.preventDefault()
                                validation.handleSubmit()
                                return false
                              }}
                            >
                              <div className="mb-3">
                                <Label className="form-label">
                                  Email
                                </Label>
                                <Input
                                  name="email"
                                  className="form-control"
                                  placeholder="Enter email"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.email || ""}
                                  invalid={
                                    validation.touched.email &&
                                    validation.errors.email
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.email &&
                                validation.errors.email ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.email}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              {forgotError && forgotError ? (
                                <Alert color="danger" style={{ marginTop: "13px" }}>
                                  {forgotError}
                                </Alert>
                              ) : null}
                              <div className="text-end">
                                <button
                                  className="btn btn-primary w-md "
                                  type="submit"
                                >
                                  Reset
                                </button>
                              </div>
                            </Form>

                            <div className="mt-5 text-center">
                              <p>
                                Remember It ?{" "}
                                <Link
                                  to="login"
                                  className="fw-medium text-primary"
                                  onClick={handleBackToLogin}
                                >
                                  {" "}
                                  Sign In here
                                </Link>{" "}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </React.Fragment>
  )
}

export default Recoverpw2
